<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img src="/assets/images/kasoft.png" width="50px" />
      KaSoft
      <span *ngIf="!shop.isPremium" style="font-size: small">Dùng thử</span>
    </a>
  </div>
  <!-- <nb-select
    [selected]="currentLanguage"
    (selectedChange)="switchLanguage($event)"
    status="primary"
  >
    <nb-option *ngFor="let lang of languages" [value]="lang.value">
      {{ lang.name }}</nb-option
    >
  </nb-select> -->
</div>

<div *ngIf="!shop.isPremium && !isMobile" class="header-container">
  <label>
    <nb-icon icon="phone-call-outline"></nb-icon>
    Gọi
    <a href="tel:+84914126840" class="link">
      <span class="text-primary">0914 126 840</span>
    </a>
    để được hướng dẫn sử dụng phiên bản chính thức
  </label>
</div>

<div *ngIf="userService.$isAuthenticated | async" class="header-container">
  <!-- <nb-actions size="small">
    <nb-action (click)="feedback()" class="control-item">
      <nb-icon icon="bulb-outline"></nb-icon>
      <span class="label-login">Góp Ý / Báo lỗi</span>
    </nb-action>
  </nb-actions> -->

  <button
    *ngIf="user.salesman"
    nbButton
    ghost
    status="primary"
    class="control-login-button"
    (click)="register()"
  >
    <nb-icon icon="person-add-outline"></nb-icon>
    <span class="label-login">Đăng ký</span>
  </button>

  <button
    nbButton
    ghost
    status="warning"
    class="control-login-button"
    (click)="showGuid()"
  >
    <nb-icon icon="question-mark-circle-outline"></nb-icon>
    <span class="label-login">Xem hướng dẫn</span>
  </button>
</div>

<div *ngIf="!(userService.$isAuthenticated | async)" class="header-container">
  <button
    nbButton
    outline
    status="primary"
    class="control-login-button"
    (click)="login()"
  >
    <nb-icon icon="power-outline"></nb-icon>
    <span class="label-login">Đăng nhập</span>
  </button>
</div>

<div *ngIf="userService.$isAuthenticated | async" class="header-container">
  <nb-actions size="medium">
    <nb-action
      *ngIf="user.working"
      [badgeText]="
        userData?.notifications < 100
          ? userData?.notifications <= 0
            ? '.'
            : userData?.notifications
          : '+99'
      "
      badgeStatus="danger"
      badgePosition="top right"
      icon="bell-outline"
      (click)="notifications()"
    ></nb-action>

    <nb-action class="user-action">
      <nb-user
        [nbContextMenu]="userMenu"
        [onlyPicture]="userPictureOnly"
        [name]="(userService.currentUser$ | async)?.displayName"
        [picture]="(userService.currentUser$ | async)?.photoURL"
      >
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
